import type { DateRange, UUID } from '@cobliteam/common-types';
import type * as Actions from './actions';
import { ReportsActionTypes as Types } from './reportsActionTypes';

export const sendDriversReportRequest = (period: DateRange, driverIds: UUID[]): Actions.SendDriversReportRequest => ({
  type: Types.SEND_DRIVERS_REPORT_REQUEST,
  payload: { period, driverIds },
});

export const sendVehiclesReportRequest = (period: DateRange, vehicleIds: UUID[]): Actions.SendVehiclesReportRequest => ({
  type: Types.SEND_VEHICLES_REPORT_REQUEST,
  payload: { period, vehicleIds },
});

export const sendDriversReportEnd = (): Actions.SendDriversReportEnd => ({
  type: Types.SEND_DRIVERS_REPORT_END,
});

export const sendDriversReportFailure = (): Actions.SendDriversReportFailure => ({
  type: Types.SEND_DRIVERS_REPORT_FAILURE,
});

export const sendVehiclesReportFailure = (): Actions.SendVehiclesReportFailure => ({
  type: Types.SEND_VEHICLES_REPORT_FAILURE,
});

export const sendVehiclesReportEnd = (): Actions.SendVehiclesReportEnd => ({
  type: Types.SEND_VEHICLES_REPORT_END,
});

export const downloadIncidentsReportRequest = (period: DateRange): Actions.DownloadIncidentsReportRequest => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_REQUEST,
  payload: period,
});

export const downloadIncidentsReportEnd = (): Actions.DownloadIncidentsReportEnd => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_END,
});
